import { render } from "./booking-adon.vue?vue&type=template&id=dcbb974e"
import script from "./booking-adon.vue?vue&type=script&lang=js"
export * from "./booking-adon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__